/**
 * Does this device actually have a hover-capable pointer?
 *
 * *** WHY EVERY RADIO/CHOICE ROW NEEDS IT. *** On touch, a tap synthesizes
 * `mouseenter` and the hover state can STICK after the finger is gone — leaving
 * an UNSELECTED row wearing the "active" treatment. On a group whose selected
 * state is also a border/fill change, "a row that looks chosen when it is not"
 * is precisely the misreading a no-default-selection group exists to prevent.
 *
 * Lifted out of `estimateRespondTokens.js` (which re-exports it, so the public
 * estimate page's imports are unchanged) when `InlineRadioGroup` shipped without
 * the guard its customer-facing twin already had. The keyboard math was already
 * shared via `radioGroupNavigation.js`; this is the interaction state catching
 * up — one control family, one definition.
 *
 * Evaluated PER CALL, never latched at mount: attaching a keyboard/trackpad or
 * flipping device emulation must re-decide. jsdom has no `matchMedia`, so the
 * default of `false` (no hover) is the safe one — hover here is pure decoration.
 */
export function supportsHover() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return window.matchMedia('(hover: hover)').matches;
  } catch {
    return false;
  }
}

export default supportsHover;
